var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShopsNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-shops-notactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M27.54 11.423c-0.146-0.219-0.38-0.366-0.641-0.401l-16.923-2.363-1.305-5.281c-0.102-0.412-0.471-0.702-0.896-0.702h-3.78c-0.51 0-0.923 0.414-0.923 0.923s0.414 0.923 0.923 0.923h3.057l4.081 16.517c0.006 0.027 0.023 0.049 0.033 0.075 0.015 0.044 0.033 0.085 0.054 0.127 0.032 0.062 0.069 0.116 0.113 0.167 0.027 0.033 0.053 0.064 0.086 0.092 0.054 0.049 0.114 0.086 0.18 0.122 0.033 0.018 0.063 0.039 0.1 0.053 0.105 0.041 0.215 0.068 0.331 0.068 0 0 0 0 0 0v0h12.425c0.421 0 0.788-0.283 0.894-0.69l2.316-8.881c0.065-0.257 0.020-0.529-0.126-0.748zM23.743 19.894h-10.991l-2.299-9.306 15.163 2.118-1.873 7.188z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M22.177 22.847c-1.786 0-3.239 1.454-3.239 3.239s1.454 3.239 3.239 3.239c1.785 0 3.238-1.454 3.238-3.239s-1.454-3.239-3.238-3.239zM22.177 27.478c-0.768 0-1.393-0.625-1.393-1.393s0.625-1.393 1.393-1.393 1.392 0.625 1.392 1.393-0.624 1.393-1.392 1.393z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M13.615 22.847c-1.786 0-3.238 1.454-3.238 3.239s1.452 3.239 3.238 3.239c1.787 0 3.242-1.454 3.242-3.239s-1.455-3.239-3.242-3.239zM13.615 27.478c-0.768 0-1.392-0.625-1.392-1.393s0.624-1.393 1.392-1.393c0.769 0 1.396 0.625 1.396 1.393s-0.626 1.393-1.396 1.393z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopsNotactive);
export default __webpack_public_path__ + "static/media/icon-shops-notactive.be0f0293.svg";
export { ForwardRef as ReactComponent };